/*==================================
  # Smooth scroll (for all anchor tags)
  # https://github.com/cferdinandi/smooth-scroll
===================================*/
var scroll = new SmoothScroll('a[href*="#"]', {

	// Selectors
	ignore: '[data-scroll-ignore]', // Selector for links to ignore (must be a valid CSS selector)
	header: '',
	topOnEmptyHash: true, // Scroll to the top of the page for links with href="#"

	// Speed & Duration
	speed: 1000, // Integer. Amount of time in milliseconds it should take to scroll 1000px
	speedAsDuration: false, // If true, use speed as the total duration of the scroll animation
	durationMax: 2000, // Integer. The maximum amount of time the scroll animation should take
	durationMin: 500, // Integer. The minimum amount of time the scroll animation should take
	clip: false, // If true, adjust scroll distance to prevent abrupt stops near the bottom of the page
	offset: 108,

	// Easing
	easing: 'easeInOutQuad', // Easing pattern to use

	// History
	updateURL: true, // Update the URL on scroll
	popstate: true, // Animate scrolling with the forward/backward browser buttons (requires updateURL to be true)

	// Custom Events
	emitEvents: true // Emit custom events

});

/*==================================
  # jQuery scripts
===================================*/

/*==================================
# Prevent Browser Anchor Jump
===================================*/
var hash = window.location.hash; //store the hash
window.location.hash = "";
//Wait till doccument is loaded
(function ($) {
	$(function(){
		if(hash){
			var fixscroll = new SmoothScroll();
			fixscroll.animateScroll(document.querySelector(hash),'',{
				header:'',
				offset:108,
				speed:1,
				durationMax:1,
				durationMin:1,

			}); 
		}
	});
})(jQuery);

(function ($) {


    /*==================================
    # Section / hero scroller
    ===================================*/

    var $scroll = $('a.imt-scroll-to-next-section');
    $scroll.on('click', function (e) {
        e.preventDefault();
        let id = e.currentTarget.id;
        id = id.replace('-heroBtn', '');
        $('html, body').animate({
            scrollTop: $('#' + id)[0].scrollHeight
        }, 800);
    });

	/*==================================
    # Header shrink on scroll
    ===================================*/
	$(window).on("scroll touchmove", function () {
		setTimeout(function(){
			$('#imt-top-bar').toggleClass('imt-topbar-sm', $(document).scrollTop() > 0);
			if ($('#imt-top-bar').hasClass('imt-topbar-sm')) {
				$('#imt-top-bar').attr('aria-hidden', true);
			} else {
				$('#imt-top-bar').attr('aria-hidden', false);
			}
			$('#imt-header').toggleClass('imt-header-sm', $(document).scrollTop() > 0);
		},10);
	});

	/*==================================
	# Document Ready
	===================================*/
	$( document ).ready(function() {

		/*==================================
		# Trigger animations on scroll
		===================================*/
		function scrollTrigger(selector){
			let els = document.querySelectorAll(selector);
			els = Array.from(els);
			els.forEach(el => {
				addObserver(el);
			});
		}

		function addObserver(el){
			let observer = new IntersectionObserver((entries, observer) => {
				entries.forEach(entry => {
					if(entry.isIntersecting){
						entry.target.classList.add('imt-animation-play');
						observer.unobserve(entry.target);
					}
				});
			});

			observer.observe(el);
		}

		//all animations to trigger on
		scrollTrigger('.imt-fade-in');
		scrollTrigger('.imt-fade-in-up');
		scrollTrigger('.imt-fade-in-down');
		scrollTrigger('.imt-fade-in-left');
		scrollTrigger('.imt-fade-in-right');
		scrollTrigger('.imt-grow-in');
		scrollTrigger('.imt-animation-default');
	});

	// before after image slider
	$("[id^=imt-before-after-slider-]").on("input change", (e) => {
		const sliderPos = e.target.value;
		let id = e.target.id;
		id = id.replace('imt-before-after-slider-', '');
		let btnWidth = $(".imt-before-after-slider-button").css("width");
		let dividerWidth = $(".imt-before-after-slider").css("min-width");

		// fine tune button position
		let finetuneleft = $("#imt-before-after-container-" + id).data("finetuneleft");
		let finetunemid = $("#imt-before-after-container-" + id).data("finetunemid");
		let finetuneright = $("#imt-before-after-container-" + id).data("finetuneright");

		// Update the width of the foreground image
		$('#imt-before-after-' + id + '-foreground-img').css('width', `${sliderPos}%`);
		// Update the position of the slider button, with position fine tuning left, right and center
		if (sliderPos <= 40) {
			$('#imt-before-after-' + id + '-slider-button').css('left', `calc(${sliderPos}% - ((${btnWidth} / 2) + (${dividerWidth} / 2)) - ${finetuneleft})`);
		} else if (sliderPos >= 60) {
			$('#imt-before-after-' + id + '-slider-button').css('left', `calc(${sliderPos}% - ((${btnWidth} / 2) + (${dividerWidth} / 2)) - ${finetuneright})`);
		} else {
			$('#imt-before-after-' + id + '-slider-button').css('left', `calc(${sliderPos}% - ((${btnWidth} / 2) + (${dividerWidth} / 2)) - ${finetunemid})`);
		}
	});


})(jQuery);